module.exports = __webpack_public_path__ + "img/994ae318-58d7-4ffa-98e1-ea97553ff0c0.c0ac0a2c.webp";